import { useMemo, useCallback } from 'react';
// import { useSelectUserContext } from '../selectors/userContext.selectors';
import { useProjects } from './useProjects';
import {
	UserProduct,
	UserProductAccessType,
	UserProductType,
	UserProductSubdomain,
} from '../types/product.types';

/**
 * Hashes are built off the value, so don't tweak
 */
export enum AdminSectionType {
	PROJECT = 0,
	ACCOUNT = 1,
}

interface UseProducts {
	/**
	 * Check if user has access to product
	 * @param product
	 * @returns
	 */
	hasProduct: (product: UserProductType) => boolean;
	/**
	 * @returns Array of all products user has acces to
	 */
	availableProducts: UserProduct[];
	/**
	 * @returns Array of all products user has acces to
	 */
	// TODO - build it's own type
	availableAdminSections: UserProduct[];
	/**
	 * @returns Array of all admin rights user has acces to
	 */
	hasAdminAccess: (adminSection: AdminSectionType) => boolean;
}

export const useProducts = (): UseProducts => {
	// const { entitlements } = useSelectUserContext();
	const { activeProject } = useProjects();

	/**
	 * An array of all products attached to a user's active project.
	 * Will show up whether they have access or not. May be undefined
	 * if projects are not yet available
	 */
	const products = useMemo(
		() => activeProject?.userProducts,
		[activeProject?.sourceId],
	);

	const activeProduct = useMemo(() => {
		const subdomain = window.location.hostname.split('.')[0];
		return UserProductSubdomain[subdomain] || null;
	}, []);

	const productAccessFilter = useCallback(
		(product: UserProduct) =>
			product.access !== UserProductAccessType.NONE &&
			product.name !== activeProduct,
		[],
	);

	const hasProduct = useCallback(
		(testProduct: UserProductType) => {
			if (!products) return false;
			//@ts-ignore
			return !!products.find<Product>(hasAccess(testProduct));
		},
		[products],
	);

	const availableProducts = useMemo((): UserProduct[] => {
		if (!products) return [];
		return products.filter(productAccessFilter);
	}, [products]);

	const hasAdminAccess = useCallback((adminSection: AdminSectionType) => {
		// Some logic to determine access to a product
		return true;
	}, []);

	const availableAdminSections = useMemo((): UserProduct[] => {
		if (!products) return [];
		// TODO make this work without hardcoding, but there is only one admin type coming back right now
		if (products[0].access !== UserProductAccessType.ADMIN) return [];
		else return [products[0]];
	}, [products]);

	return {
		availableProducts,
		availableAdminSections,
		hasProduct,
		hasAdminAccess,
	};
};
